import { render } from "./ChatTab.vue?vue&type=template&id=53879098&scoped=true"
import script from "./ChatTab.vue?vue&type=script&lang=js"
export * from "./ChatTab.vue?vue&type=script&lang=js"

import "./ChatTab.vue?vue&type=style&index=0&id=53879098&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53879098"]])

export default __exports__